import React from 'react';
import { useRive } from '@rive-app/react-canvas';

import {
  BACKGROUNDS_CONFIG,
  PICTURES_CONFIG,
  RIVE_CONFIG,
} from '@/common/config/media-config';
import { PageBackground } from '@/components/ui/Backgrounds/PageBackground/PageBackground';
import { Picture } from '@/components/ui/Picture/Picture';

// import { Picture } from '@/components/ui/Picture/Picture';
// import vipCharacterPng from '/img/tony-vip.png';
// import vipCharacterWebp from '/img/tony-vip.webp';

const Vip: React.FC = () => {
  const { RiveComponent } = useRive({
    src: RIVE_CONFIG?.VIP_TONY,
    autoplay: true,
  });

  return (
    <PageBackground
      className="after:z-[3] h-auto w-[100%]"
      pictureClassName="relative z-[2]"
      variant="page"
      backgroundImage={{
        png: BACKGROUNDS_CONFIG.BG_OFFICE_VIP.png,
        webp: BACKGROUNDS_CONFIG.BG_OFFICE_VIP.webp,
      }}
    >
      {!RIVE_CONFIG?.VIP_TONY ? (
        PICTURES_CONFIG.TONY_VIP && (
          <Picture
            className="absolute z-[3] bottom-0 left-1/2 -translate-x-1/2 aspect-[808/794] w-[93%]"
            img={PICTURES_CONFIG.TONY_VIP.png}
            webp={PICTURES_CONFIG.TONY_VIP.webp}
            alt="vip character"
          />
        )
      ) : (
        <RiveComponent className="absolute z-[3] bottom-[-50px] left-1/2 -translate-x-1/2 aspect-[180/228] w-[85%]" />
      )}
    </PageBackground>
  );
};

export default Vip;
